import React, { useState } from "react";
import { Button } from "@mui/material";
import { isAssumed } from "utils/jwtRole";
import { getActingAs, restorePlatformSeat } from "utils/assumedSeat";

// Multi-tenancy "borrow a seat": slim strip above the header while the super
// admin is inside a tenant on an assumed token. Gated on actingAs + the
// token's assumed:true claim — NOT on isSuperAdmin(), because the assumed
// token carries the borrowed tenant role, not 99.
function ActingAsBanner() {
  const [busy, setBusy] = useState(false);
  const actingAs = getActingAs();
  if (!actingAs || !isAssumed()) return null;

  // Both buttons put the super admin back on the platform seat first (the
  // /select-tenant and /create-tenant routes only exist for role 99). With no
  // stashed platform token there is nothing to restore — fall back to a clean
  // logout rather than leaving a half-broken assumed session behind.
  const leaveSeat = async (destination) => {
    if (busy) return;
    setBusy(true);
    const restored = await restorePlatformSeat();
    if (!restored) {
      localStorage.clear();
      window.location.replace("/login");
      return;
    }
    window.location.replace(destination);
  };

  return (
    <div
      className="flex items-center gap-3 px-5"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "6px 20px",
        background: "var(--brand-accent, #F4B400)",
        color: "#0B2545",
        fontSize: 13,
      }}
    >
      {actingAs.logo && (
        <img
          src={actingAs.logo}
          alt="tenant logo"
          style={{
            height: 22,
            width: 22,
            objectFit: "contain",
            borderRadius: 4,
            background: "#fff",
          }}
        />
      )}
      <span className="fontMedium">
        Acting as {actingAs.name} — {actingAs.roleName}
      </span>
      <span style={{ flexGrow: 1 }} />
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        disabled={busy}
        onClick={() => leaveSeat("/select-tenant")}
      >
        Switch tenant
      </Button>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        disabled={busy}
        onClick={() => leaveSeat("/create-tenant")}
      >
        Exit
      </Button>
    </div>
  );
}

export default ActingAsBanner;
